<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Please choose the predefined answer code for Intelex</h4>
    <button
      mat-button
      [mat-dialog-close]=""
      (click)="onCancel()"
      cdkFocusInitial
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="evenly dialog-content">
    <mat-radio-group
      class="answerRadio"
      [(ngModel)]="answerSelected"
      color="primary"
    >
      @for (st of data.answers; track st) {
      <mat-radio-button
        class="intelexAnswer"
        color="primary"
        [value]="st"
        (change)="radioChange($event)"
      >
        {{st}}
      </mat-radio-button>
      }
    </mat-radio-group>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      (click)="onConfirm()"
      [disabled]="answerSelected.length === 0"
      class="button-close"
      cdkFocusInitial
    >
      Confirm
    </button>
    <button
      mat-button
      (click)="onCancel()"
      mat-dialog-close
      class="button-close"
    >
      Cancel
    </button>
  </div>
</div>
